export default __webpack_public_path__ + "static/media/köide-30-31.b7eda877.png";